import { theme } from 'lib';

const Toggle = ({ on, onToggle }) => (
  <div
    onClick={onToggle}
    style={{
      position: 'relative',
      width: '44px',
      height: '24px',
      borderRadius: '12px',
      backgroundColor: on ? '#e53935' : (theme.GREY_30 || '#ccc'),
      cursor: 'pointer',
      transition: 'background-color 0.2s',
      flexShrink: 0
    }}
  >
    <div
      style={{
        position: 'absolute',
        top: '3px',
        left: on ? '23px' : '3px',
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        backgroundColor: '#fff',
        transition: 'left 0.2s',
        boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
      }}
    />
  </div>
);

export default Toggle;
